/*************
 * tabToggle
 * 
 * This module handles the tab toggle functionality for tabbed views in the application.
 *
 */

custom.tabToggle = (() => {
    const QUERY_PARAM = 'collab-view';

    const activateTab = ($trigger) => {
        const showTarget = $trigger.data('target');
        const hideTarget = $trigger.data('hide');
        const scrollTarget = $trigger.data('scroll-target');

        // Add active class to the clicked tab and corresponding content
        $('.js-tab-toggle').each(function() {
            if ($(this).data('target') === showTarget) {
                $(this).addClass('active');
                return;
            }
            $(this).removeClass('active');
        });

        $(showTarget).removeClass('hidden');
        $(hideTarget).addClass('hidden');

        return scrollTarget;
    };

    const scrollToTarget = (scrollTarget) => {
        if (scrollTarget && $(`#${scrollTarget}`).length) {
            const scrollPosition = $(`#${scrollTarget}`).offset().top - 80;
            window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
        }
    };

    const updateUrlParam = (scrollTarget) => {
        if (!scrollTarget) return;
        const url = new URL(window.location.href);
        url.searchParams.set(QUERY_PARAM, scrollTarget);
        window.history.replaceState({ collabView: scrollTarget }, document.title, url.toString());
    };

    const activateFromQueryParam = () => {
        const requestedView = new URLSearchParams(window.location.search).get(QUERY_PARAM);
        if (!requestedView) return;

        const $trigger = $('.js-tab-toggle').filter(function() {
            return $(this).data('scroll-target') === requestedView;
        }).first();
        if (!$trigger.length) return;

        const scrollTarget = activateTab($trigger);
        setTimeout(() => scrollToTarget(scrollTarget), 500);
    };

    const init = () => {
        $('.js-tab-toggle').on('click', function(event) {
            event.preventDefault();
            const $this = $(this);
            const scrollTarget = activateTab($this);
            scrollToTarget(scrollTarget);
            updateUrlParam(scrollTarget);
        });

        activateFromQueryParam();
    }
  /**
   * API
   */
  return {
    init
  };
})();
custom.tabToggle.init();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/tab-toggle.js